import React, { useContext } from 'react';
import { ParamsAndReturnTypes } from '@prisjakt/ui-translate/src/translate-func';
import { AppContext } from '@prisjakt/ui-app-context';
import { ProductPriceType } from '../../../../../../../types';

import * as S from './styles';

type OwnProps = {
  className?: string;
  type: ProductPriceType;
  hideText?: boolean;
  color?: 'light' | 'dark';
};

type Props = OwnProps;

const PriceNotice = ({
  className,
  type,
  hideText = false,
  color = 'light',
}: Props) => {
  const { t } = useContext(AppContext);

  if (type === ProductPriceType.NORMAL) return null;

  return (
    <S.PriceNotice hideText={hideText} className={className} color={color}>
      <S.InfoIcon size={16} />
      <S.Text>
        {t(
          'product',
          `price-notice.${type}` as keyof ParamsAndReturnTypes['product']
        )}
      </S.Text>
    </S.PriceNotice>
  );
};

export default PriceNotice;
